import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Message } from './types';
import { SystemMessage, SystemMessageProps } from 'react-native-gifted-chat';

export const ChatSystemMessage: React.FC<SystemMessageProps<Message>> = (
  props,
) => {
  const [styles] = useStyles();
  return (
    <SystemMessage {...props} textStyle={[TYPOGRAPHY.small, styles.base]} />
  );
};

const useStyles = createStyles((theme) => ({
  base: {
    ...FONTS.primarySemiBold,
    color: theme.colors.inactiveText,
  },
}));
